// src/components/Dashboard.jsx
import React from "react";

export function Dashboard({ username, onCreate, onLogout, children }) {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-md space-y-6">
      <h1 className="text-3xl font-bold text-gray-800">
        Welcome, {username.charAt(0).toUpperCase() + username.slice(1)}
      </h1>
      <div className="flex gap-4">
        <button
          onClick={onCreate}
          className="bg-green-600 text-white font-semibold px-5 py-2 rounded hover:bg-green-700 transition"
        >
          + Create New Quiz
        </button>
        <button
          onClick={onLogout}
          className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600 transition"
        >
          Logout
        </button>
      </div>
      {children}
    </div>
  );
}
